import Sortable from 'sortablejs';
import {checkColumn, handleError} from '../util/componentUtil';
import {compareTree, copyTree} from '@/util/componentCoreUtil';
// import Storage from '@/util/storage';
import {misConfigureExtensionSaveOrUpdate, misConfigureListUser, saveTableColumnMsg} from '../api/misConfigApi';
import {
  NO_STORAGE,
  LOCAL_STORAGE,
  REMOTE_STORAGE,
  OBJECT_TYPE_TABLE_SETTING,
  SCOPE_PRIVATE,
  TABLE_SETTING_STYLE,
  FIXED_LEFT_COLUMN,
  FIXED_RIGHT_COLUMN, CLEAR_FIXED_COLUMN
} from '@/util/table-setting-constant';
import Vue from 'vue';
// import {defaultRemote} from '@/util/appUtils';
import {getSysUser} from '@/util/user';
import {Notification} from 'element-ui';
/**
 * @desc 表格配置相关操作的mixin
 * 行和列拖拽，为了保证行和列拖拽的正确性，需要对vxe-grid或者vxe-table设置scroll-x="{gt: -1}"和scroll-x="{gt: -1}"来关闭虚拟滚动功能
 * 注意： vxe-grid和vxe-table都要设置columnKey,因为拖拽涉及dom操作
 * @date 2021-06-07
 */
export default {
  created() {
    // 记录调用api查询已有样式是否成功
    this.getApiError = false;
  },
  methods: {
    handleMenuClick ({$table, menu}) {
      const code = menu.code;
      if (code === TABLE_SETTING_STYLE) {
        if (this.tableSettingConfig.storage !== REMOTE_STORAGE) {
          return;
        }
        const self = this;
        const Wrapper = Vue.extend({
          name: 'XTableSettingDialogWrapper',
          data() {
            return {
              visible: false
            };
          },
          render (createElement) {
            return this.visible ? createElement('x-table-setting-dialog', {
              attrs: {
                visible: true
              },
              props: {
                baseMisConfigure: {name: self.columnCache, objectType: OBJECT_TYPE_TABLE_SETTING},
                currentMisConfigure: self.misConfigure,
                handleSelect: self.setMisConfigure
              },
              on: {
                'update:visible': (args) => {
                  if (args === false) {
                    wrapper.$destroy();
                  }
                }
              }
            }) : null;
          }
        });
        const wrapper = new Wrapper({
          el: document.createElement('div'),
          parent: $table.$root
        });
        setTimeout(() => {
          wrapper.visible = true;
        }, 10);
        return;
      }
      if (code === FIXED_LEFT_COLUMN || code === FIXED_RIGHT_COLUMN || code === CLEAR_FIXED_COLUMN) {
        if (this.handleTableSettingUpdate) {
          this.handleTableSettingUpdate({$grid: this.getGridInstance()});
        }
        this.saveTableColumnMsg();
      }
    },
    restoreColumnDrag() {
      if (Array.isArray(this.sortableArrray)) {
        for (const item of this.sortableArrray) {
          item.destroy();
        }
      }
      this.sortableArrray = [];
    },
    initColumnDrag() {
      const xTable = this.getGridInstance();
      if (!xTable) {
        return;
      }
      const invalidColumn = checkColumn({columns: xTable.getTableColumn().collectColumn});
      if (invalidColumn) {
        Notification.error(invalidColumn.title + '未设置field或者field重复');
        throw new Error(invalidColumn.title + '未设置field或者field重复');
      }
      // 防止多次调用初始化方法导致内存泄漏，先调用一次初始化方法释放内存
      this.restoreColumnDrag();
      if (!this.realTableSettingConfig.columnDraggable) {
        return;
      }
      const elementArray = xTable.$el.querySelectorAll('.vxe-table--main-wrapper .body--wrapper>.vxe-table--header .vxe-header--row');
      for (let i = 0; i < elementArray.length; i++) {
        this.sortableArrray.push(Sortable.create(elementArray[i], {
          scrollSpeed: 100,
          scrollSensitivity: 30,
          swapThreshold: 1.6,
          forceFallback: true,
          scroll: true,
          handle: '.vxe-cell',
          delay: 50,
          touchStartThreshold: 30,
          draggable: '.vxe-header--column:not(.col--fixed)',
          filter: '.vxe-header--gutter',
          onMove: (event) => {
            const {dragged, related} = event;
            const grid = this.getGridInstance();
            const {parent} = grid.getColumnNode(dragged);
            if (!parent) {
              return true;
            }
            // 找出parent对应的dom
            const parentNode = xTable.$el.querySelector(`.vxe-table--main-wrapper .body--wrapper>.vxe-table--header .vxe-header--row .vxe-header--column[colid=${parent.id}]`);
            const offsetLeft = parentNode.offsetLeft;
            const offsetWidth = parentNode.offsetWidth;
            const relatedOffsetLeft = related.offsetLeft;
            // 使用vxe-grid的api,判断related和dragged是否在同一父元素下边界情况下会提早返回false,导致无法拖拽到最后一个元数
            // 数字2是为了容错
            // 如果offsetLeft - relatedOffsetLeft > 2 表示related在parent的左外边
            // offsetLeft + offsetWidth - relatedOffsetLeft < 2 表示related在parent的右外边
            if (offsetLeft - relatedOffsetLeft > 2 || offsetLeft + offsetWidth - relatedOffsetLeft < 2) {
              return false;
            }
            return true;
          },
          // onUpdate,只有顺序发生改变时才发触发，性能比onEnd好, oldIndex是拖拽开始位置，newIndex是拖拽完成的位置
          onUpdate: (event) => {
            const {newIndex, oldIndex, item} = event;
            const grid = this.getGridInstance();
            // index是item在其父元素中的位置
            const {parent, index, item: columnItem} = grid.getColumnNode(item);
            const {collectColumn} = grid.getTableColumn();
            let children;
            let allChildren;
            if (parent) {
              children = parent.children;
              allChildren = [columnItem];
              let _item = item;
              while (true) {
                if (_item.previousElementSibling) {
                  _item = _item.previousElementSibling;
                  allChildren.unshift(grid.getColumnNode(_item).item);
                } else {
                  break;
                }
              }
              _item = item;
              while (true) {
                if (_item.nextElementSibling) {
                  _item = _item.nextElementSibling;
                  const columnNode = grid.getColumnNode(_item);
                  // 数据量增加，出现滚动条，vxe-table会在最右边增加一个<th class="vxe-header--gutter col--gutter"></th>
                  // 因此需要判断是不是有对应的columnNode
                  if (columnNode) {
                    allChildren.push(columnNode.item);
                  }
                } else {
                  break;
                }
              }
              // 根据dom获取的allChildren顺序是发了改变的，这里要调整回来
              allChildren.splice(oldIndex, 0, allChildren.splice(newIndex, 1)[0]);
            } else {
              allChildren = collectColumn;
              children = collectColumn;
            }
            // 由于有些column是隐藏的,所以要构造一个数组，与界面的显示保持一致
            const list = [];
            for (const column of allChildren) {
              if (!column.visible) {
                continue;
              }
              list.push(column);
            }
            // 对fixed的列重新排序,因为vxe-table会根据fixed来重新调整dom的顺序
            list.sort((col1, col2) => {
              const FIXED_LEFT = 'left';
              const FIXED_RIGHT = 'right';
              if (col1.fixed === FIXED_LEFT) {
                if (col2.fixed === FIXED_LEFT) {
                  return 0;
                } else {
                  return -1;
                }
              }
              if (col1.fixed === FIXED_RIGHT) {
                if (col2.fixed === FIXED_RIGHT) {
                  return 0;
                } else {
                  return 1;
                }
              }
              return 0;
            });
            const column = list[newIndex];
            const newColumnIndex = children.indexOf(column);
            // 由于在拖拽的过程中，在某些情况下被拖拽的元素会放到tr的最后一个元数，超出了父元素的范围，所以这里直接回滚
            if (newColumnIndex < 0) {
              const parentElement = item.parentElement;
              const refItem = parentElement.children[oldIndex];
              parentElement.removeChild(item);
              parentElement.insertBefore(item, refItem);
              return;
            }
            // newIndex < oldIndex, 即向前移动，就要先将index对应的元素从children中取出，再放入newColumnIndex的位置，原来newColumnIndex及后面元素后移一位
            // newIndex > oldIndex, 即向后移动，操作也是一样， item = children.splice(index, 1)[0], 因为splice(index, 1)会使后面的所有元素前移一位，splice(newColumnIndex, 0, item)插入新元素，
            // newColumnIndex后面所有元素后移一位，即newColumnIndex后面的元素位置与原来对比不变，最终结果是item的位置由index转到newColumnIndex
            children.splice(newColumnIndex, 0, children.splice(index, 1)[0]);
            grid.loadColumn(collectColumn).then(() => {
              if (this.handleTableSettingUpdate) {
                this.handleTableSettingUpdate({$grid: this.getGridInstance()});
              }
              this.saveTableColumnMsg();
            });
          },
          onEnd() {
            const fixedWrapperElement = xTable.$el.querySelector('.vxe-table--fixed-wrapper');
            if (fixedWrapperElement && fixedWrapperElement.style.getPropertyValue('display') === 'none') {
              fixedWrapperElement.style.removeProperty('display');
            }
          },
          // onChoose是点击时就会触发，如点击表头的排序按钮也会触发
          // onStart是刚开始拖拽时触发，只触发一次，性能比onChoose好
          onStart: () => {
            const fixedWrapperElement = xTable.$el.querySelector('.vxe-table--fixed-wrapper');
            if (fixedWrapperElement) {
              fixedWrapperElement.style.setProperty('display', 'none');
            }
          }
        }));
      }
    },
    handleInitTableSetting () {
      this.initColumnDrag();
      if (this.handleTableSettingUpdate) {
        this.handleTableSettingUpdate({$grid: this.getGridInstance()});
      }
    },
    async initTableSetting() {
      const grid = this.getGridInstance();
      const invalidColumn = checkColumn({columns: grid.getTableColumn().collectColumn});
      if (invalidColumn) {
        Notification.error(invalidColumn.title + '未设置field或者field重复');
        return Promise.reject(new Error(invalidColumn.title + '未设置field或者field重复'));
      }
      /*const loginUser = this.$access.getInfo();
      if (!this.columnCache) {
        const info = {type: 'no columnCache'};
        if (loginUser) {
          info.userId = loginUser.userId;
        }
        defaultRemote({
          url: window.location.href,
          frontAppName: this.$access.options.systemType || '',
          info: JSON.stringify(info)
        });
        this.handleInitTableSetting();
        return;
      }*/
      const storage = this.realTableSettingConfig.storage;
      // 没有开启tableSetting的存储功能就直接返回
      if (storage === NO_STORAGE) {
        this.handleInitTableSetting();
        return;
      }
      // 如果是开启了本地存储
      if (storage === LOCAL_STORAGE) {
        const json = storage.get(this.columnCache);
        if (!json || !json.collectColumn) {
          this.handleInitTableSetting();
          return;
        }
        const localCollectColumn = json.collectColumn;
        if (JSON.stringify(this.getSimpleCollectColumn()) === JSON.stringify(localCollectColumn)) {
          this.handleInitTableSetting();
          return;
        }
        await grid.loadColumn(this.getAdjustColumn(localCollectColumn));
        this.handleInitTableSetting();
        return;
      }
      if (storage !== REMOTE_STORAGE) {
        return Promise.reject(new RuleError('没有正确设置storage'));
      }
      let res;
      try {
        res = await this.realTableSettingConfig.getApi({name: this.columnCache, objectType: OBJECT_TYPE_TABLE_SETTING});
      } catch (e) {
        this.getApiError = true;
        /*const info = {type: 'getTableStyle api fail'};
        if (loginUser) {
          info.userId = loginUser.userId;
        }
        defaultRemote({
          url: window.location.href,
          frontAppName: this.$access.options.systemType || '',
          info: JSON.stringify(info)
        });*/
        handleError(e);
      }
      if (!res.isSuccess()) {
        this.getApiError = true;
        /*const info = {type: 'query misConfig fail'};
        if (loginUser) {
          info.userId = loginUser.userId;
        }
        defaultRemote({
          url: window.location.href,
          frontAppName: this.$access.options.systemType || '',
          info: JSON.stringify(info),
          message: res.msg
        });*/
        Notification.error(res.msg);
        return Promise.reject(new RequestError(res.msg));
      }
      this.getApiError = false;
      const data = res.data;
      const list = data.list;
      const misConfigureExtension = data.misConfigureExtension;
      this.misConfigureExtension = misConfigureExtension;
      if (!Array.isArray(list) || list.length < 1) {
        return this.handleInitTableSetting();
      }
      // 获取配置详情，如果没有设置默认就是使用表格原来的样式
      let item = null;
      if (misConfigureExtension && misConfigureExtension.defaultConfigure) {
        for (const config of list) {
          if (config.id === misConfigureExtension.defaultConfigure) {
            item = config;
            break;
          }
        }
      }
      this.misConfigure = item;
      if (!item) {
        return this.handleInitTableSetting();
      }
      const objectJson = item.objectJson;
      const json = JSON.parse(objectJson);
      // 如果服务端没有，或者本地和服务端一致，就不需要处理
      const remoteCollectColumn = json.collectColumn;
      if (!remoteCollectColumn || JSON.stringify(this.getSimpleCollectColumn()) === JSON.stringify(remoteCollectColumn)) {
        return this.handleInitTableSetting();
      }
      await grid.loadColumn(this.getAdjustColumn(remoteCollectColumn));
      return this.handleInitTableSetting();
    },
    async setMisConfigure({misConfigure, misConfigureExtension}) {
      this.misConfigure = misConfigure;
      this.misConfigureExtension = misConfigureExtension;
      if (misConfigure) {
        const json = JSON.parse(misConfigure.objectJson);
        await this.loadRemoteColumn({remoteCollectColumn: json.collectColumn, reload: true});
      } else {
        if (this.getOriginalColumns) {
          const grid = this.getGridInstance();
          grid.reloadColumn(this.getOriginalColumns());
        }
      }
      if (this.handleMisConfigureChange) {
        await this.handleMisConfigureChange({misConfigure, misConfigureExtension});
      }
      if (this.handleTableSettingUpdate) {
        this.handleTableSettingUpdate({$grid: this.getGridInstance()});
      }
    },
    getMisConfigure() {
      return this.misConfigure;
    },
    async loadRemoteColumn({remoteCollectColumn, reload}) {
      const grid = this.getGridInstance();
      if (reload) {
        await grid.reloadColumn(this.getAdjustColumn(remoteCollectColumn));
      } else {
        await grid.loadColumn(this.getAdjustColumn(remoteCollectColumn));
      }
      this.handleInitTableSetting();
    },
    /**
     * 获取调整了顺序，width和visible后的column
     * @param referenceCollectColumn 参照标准
     * @return {Promise<void>|ColumnInfo[]}
     */
    getAdjustColumn (referenceCollectColumn) {
      const {collectColumn} = this.getGridInstance().getTableColumn();
      // 先对比字段是不是一致，避免先改变children内元素的顺序，改变children内元素的顺序会直接影响组件
      if (!compareTree({reference: referenceCollectColumn, target: collectColumn, validate: ({targetItem, referenceItem}) => { return targetItem.property === referenceItem.property; }})) {
        console.log('字段不一致');
        return collectColumn;
      }
      function getAdjustColumnRecursive ({reference, target}) {
        if (!Array.isArray(reference) || !Array.isArray(target)) {
          return;
        }
        for (let i = 0; i < reference.length; i++) {
          const referenceItem = reference[i];
          for (let j = i; j < target.length; j++) {
            const targetItem = target[j];
            if (targetItem.property === referenceItem.property) {
              // 设置visible和width
              targetItem.visible = referenceItem.visible;
              // || 0是为了兼容旧数据，之前上传数据是resizeWidth如果是0，就不会提交到数据库，造成referenceItem没有resizeWidth属性
              // 这种情况下切换表格样式，有可能有些列会保留上一个样式宽度
              targetItem.resizeWidth = referenceItem.resizeWidth || 0;
              if (Object.prototype.hasOwnProperty.call(referenceItem, 'fixed')) {
                // 兼容之前部页面使用固定列
                targetItem.fixed = referenceItem.fixed;
              }
              // 调整位置
              if (i !== j) {
                target.splice(i, 0, target.splice(j, 1)[0]);
              }
              break;
            }
          }
          getAdjustColumnRecursive({reference: referenceItem.children, target: target[i].children});
        }
      }
      getAdjustColumnRecursive({reference: referenceCollectColumn, target: collectColumn});
      return collectColumn;
    },
    /**
     * @desc 保存表格的配置信息
     * @param id
     * @param idProperty
     * @param objectType
     * @param objectJson
     * @return {Promise<unknown>}
     */
    async saveTableColumnMsg() {
      if (!this.columnCache) {
        return Promise.resolve();
      }
      const storage = this.realTableSettingConfig.storage;
      if (storage === NO_STORAGE) {
        return Promise.resolve();
      }
      if (storage === LOCAL_STORAGE) {
        storage.set(this.columnCache, {collectColumn: this.getSimpleCollectColumn()});
        return Promise.resolve();
      }
      if (storage !== REMOTE_STORAGE) {
        return Promise.reject(new Error('没有正确设置storage'));
      }
      const sysUser = getSysUser();
      if (!sysUser) {
        return Promise.reject(new RuleError('用户未登录'));
      }
      if (this.getApiError) {
        /*const info = {type: 'reject save for getApiError', userId: sysUser.id};
        defaultRemote({
          url: window.location.href,
          frontAppName: this.$access.options.systemType || '',
          info: JSON.stringify(info)
        });*/
        return Promise.reject(new RuleError('查询已有样式报错，请刷新后再试'));
      }
      const params = {
        name: this.columnCache,
        objectType: OBJECT_TYPE_TABLE_SETTING,
        // 为了方便以后扩展objectJson多设置一层
        objectJson: JSON.stringify({collectColumn: this.getSimpleCollectColumn()}),
        scope: SCOPE_PRIVATE,
        configureName: '自动创建'
      };
      if (this.misConfigure) {
        // 判断该方法是不是用户创建，如果是使用别人的共享方案，就新建一个
        if (this.misConfigure.creator === sysUser.id) {
          params.id = this.misConfigure.id;
        }
        params.scope = this.misConfigure.scope;
        params.configureName = this.misConfigure.configureName;
      }
      const res = await this.realTableSettingConfig.saveApi(params, {originResponse: false});
      if (!res.isSuccess()) {
        return Promise.reject(new RequestError(res.msg));
      }
      // 如果没有misConfigureExtension，就需要创建
      // 如果没有misConfig，表示没有默认是样式，也许设置为默认
      if (!this.misConfigureExtension || !this.misConfigure) {
        const params1 = {name: this.columnCache};
        if (!this.misConfigure) {
          params1.defaultConfigure = res.data.id;
        }
        const res1 = await misConfigureExtensionSaveOrUpdate(params1);
        if (res1.isFail()) {
          return Promise.reject(new RequestError(res1.msg));
        }
        this.misConfigureExtension = res1.data;
      }
      this.misConfigure = res.data;
      return Promise.resolve(res.data);
    },
    getSimpleCollectColumn () {
      // 参考源码
      // node_modules/vxe-table/packages/table/src/methods.js
      // saveCustomResizable方法和saveCustomVisible方法
      // saveCustomResizable保存的resizeWith其实是renderWidth的值
      const {collectColumn} = this.getGridInstance().getTableColumn();
      return copyTree({
        source: collectColumn,
        copyMethod: ({item}) => {
          const newItem = {};
          // 没有经过拖拽的resizeWidth是0
          // node_modules/vxe-table/packages/tools/src/utils.js ColumnInfo的构造方法
          // renderWidth是最终渲染的宽度
          newItem.resizeWidth = item.resizeWidth;
          newItem.visible = item.visible;
          newItem.property = item.property;
          newItem.fixed = item.fixed;
          return newItem;
        }
      });
    }
  },
  beforeDestroy() {
    this.restoreColumnDrag();
  },
  computed: {
    realTableSettingConfig() {
      const defaultTableSettingConfig = {
        columnDraggable: true,
        rowDraggable: false,
        getApi: misConfigureListUser,
        saveApi: saveTableColumnMsg,
        storage: REMOTE_STORAGE
      };
      if (!this.tableSettingConfig) {
        return defaultTableSettingConfig;
      }
      return Object.assign(defaultTableSettingConfig, this.tableSettingConfig);
    }
  }
};
